module.exports = __webpack_public_path__ + "c68e15e5d97dbeda0437340ebc1a0bd9.pdf";